import { render, staticRenderFns } from "./Receives.vue?vue&type=template&id=6e6a6469"
import script from "./Receives.vue?vue&type=script&lang=js"
export * from "./Receives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports